export default __webpack_public_path__ + "static/comingsoon-bg-84a395c816240570969bb1efa0834361.png";